/// <amd-module name="Reporting/DataQuality/DataQualityService" />
/**
 * Service class to enable surfacing of whitelisted data quality warnings to users.
 */
export default class DataQualityService {
    /**
     * This method evaluates warnings according to preset policies / thresholds to determine what must be surfaced.
     * @param warnings
     */
    public static evaluate(warnings: string[] | undefined): string {
        if (warnings && warnings.length > 0) {
            return warnings[0];
        }

        return "";
    }
}
